const FranceMap = [
    {"id":"1634525121","name":"Adh Dhakhīrah","Gouv":"Al Khawr wa adh Dhakhīrah","country":"QA","lat":"25.7347","lng":"51.5475"},
{"id":"1634232373","name":"Al Jumaylīyah","Gouv":"Ash Shīḩānīyah","country":"QA","lat":"25.6208","lng":"51.0819"},
{"id":"1634786937","name":"Al Khawr","Gouv":"Al Khawr wa adh Dhakhīrah","country":"QA","lat":"25.69","lng":"51.51"},
{"id":"1634261569","name":"Al Wakrah","Gouv":"Al Wakrah","country":"QA","lat":"25.18","lng":"51.61"},
{"id":"1634097551","name":"Ar Rayyān","Gouv":"Ar Rayyān","country":"QA","lat":"25.25","lng":"51.4"},
{"id":"1634539520","name":"Ash Shīḩānīyah","Gouv":"Ash Shīḩānīyah","country":"QA","lat":"25.3722","lng":"51.2047"},
{"id":"1634890537","name":"Az̧ Z̧a‘āyin","Gouv":"Az̧ Z̧a‘āyin","country":"QA","lat":"25.5669","lng":"51.4847"},
{"id":"1634459660","name":"Doha","Gouv":"Ad Dawḩah","country":"QA","lat":"25.2867","lng":"51.5333"},
{"id":"1634292106","name":"Laqţah","Gouv":"Ash Shīḩānīyah","country":"QA","lat":"25.4175","lng":"51.5075"},
{"id":"1634762661","name":"Madīnat ash Shamāl","Gouv":"Ash Shamāl","country":"QA","lat":"26.1167","lng":"51.2167"},
{"id":"1634400511","name":"Nu‘ayjah","Gouv":"Ad Dawḩah","country":"QA","lat":"25.2525","lng":"51.5592"},
{"id":"1634017384","name":"Umm Qurūn","Gouv":"Ar Rayyān","country":"QA","lat":"25.25","lng":"51.3732"},
{"id":"1634646507","name":"Umm Şalāl ‘Alī","Gouv":"Umm Şalāl","country":"QA","lat":"25.4697","lng":"51.3975"}

]

export default FranceMap